import React from "react";

// React Router Dom Link
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      {/* Footer */}
      <footer>
        <div className="container">
          <div className="card footer">
            <div className="section footer-top">
              <div className="footer-brand">

                <Link to="#" className="logo">

                  <img
                    src="/assets/images/portfolio-logo1.png"
                    width={119}
                    height={37}
                    loading="lazy"
                    alt="prabhsingh.in"
                  />
                </Link>
                <p className="footer-text">

                  Prabhjeet Singh, a living testament to the potential that lies within the intersections of passion, talent, and ambition. He is a shining example of how one person can excel in numerous areas. He's an entrepreneur who turns ideas into reality, a lifestyle influencer who inspires people to be themselves, and a web application developer who builds beautiful and functional websites.
                </p>
                {/* <p className="footer-list-title">Address</p>
                <address className="footer-text address">
                  New Gurnam Nagar,<br /> Amritsar, Punjab.<br />143001
                </address> */}
              </div>
              <div className="footer-list">
                <p className="footer-list-title">Categories</p>
                <ul>
                  <li>
                    <Link to="#" className="footer-link hover-2">
                      Intrepreneur
                    </Link>
                  </li>
                  <li>

                    <Link to="#" className="footer-link hover-2">
                      Influencer
                    </Link>
                  </li>
                  <li>

                    <Link to="#" className="footer-link hover-2">
                      Blogger
                    </Link>
                  </li>
                  <li>

                    <Link to="#" className="footer-link hover-2">
                      Youtuber
                    </Link>
                  </li>
                  <li>

                    <Link to="#" className="footer-link hover-2">
                      Desinger
                    </Link>
                  </li>
                  <li>

                    <Link to="#" className="footer-link hover-2">
                      SEO
                    </Link>
                  </li>
                  <li>

                    <Link to="#" className="footer-link hover-2">
                      Photography
                    </Link>
                  </li>
                  <li>

                    <Link to="#" className="footer-link hover-2">
                      Cinematography
                    </Link>
                  </li>
                  <li>

                    <Link to="#" className="footer-link hover-2">
                      Film Making
                    </Link>
                  </li>
                  <li>

                    <Link to="#" className="footer-link hover-2">
                      VFX
                    </Link>
                  </li>
                  <li>

                    <Link to="#" className="footer-link hover-2">
                      Brand Making
                    </Link>
                  </li>
                  <li>

                    <Link to="#" className="footer-link hover-2">
                      Marketing
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer-list">
                <p className="footer-list-title">Newsletter</p>
                <p className="footer-text">

                  Sign up to be first to receive the latest stories inspiring
                  us, case studies, and industry news.
                </p>
                <div className="input-wrapper">

                  <input
                    type="text"
                    name="name"
                    placeholder="Your name"
                    required=""
                    className="input-field"
                    autoComplete="off"
                  />
                  <ion-icon name="person-outline" aria-hidden="true" />
                </div>
                <div className="input-wrapper">
                  <input
                    type="email"
                    name="email_address"
                    placeholder="Emaill address"
                    required=""
                    className="input-field"
                    autoComplete="off"
                  />
                  <ion-icon name="mail-outline" aria-hidden="true" />
                </div>
                <Link to="#" className="btn btn-primary">

                  <span className="span">Subscribe</span>
                  <ion-icon name="arrow-forward" aria-hidden="true" />
                </Link>
              </div>
            </div>
            <div className="footer-bottom">
              <p className="copyright">

                © Developed by {' '}
                <Link to="https://prabhsingh.in" className="copyright-link">
                  PrabhSingh.in
                </Link>
              </p>
              <ul className="social-list">
                <li>

                  <Link to="https://github.com/prabhsingh13" className="social-link">

                    <ion-icon name="logo-github" />
                    <span className="span">Github</span>
                  </Link>
                </li>
                <li>

                  <Link to="https://www.linkedin.com/in/prabhsingh13/" className="social-link">

                    <ion-icon name="logo-linkedin" />
                    <span className="span">LinkedIn</span>
                  </Link>
                </li>
                <li>

                  <Link to="https://instagram.com/prabhsingh.13" className="social-link">

                    <ion-icon name="logo-instagram" />
                    <span className="span">Instagram</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="empty" />
        </div>
      </footer>
    </>
  );
}

export default Footer;
